module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ACbOtJ/tc-custom/9781617454813.jpg?1704513916121",
      "alt": "This image is the cover for the book Seasons of Wool Appliqué Folk Art"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Seasons of Wool Appliqué Folk Art\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Enjoy wool appliqué all year round with 12 seasonal projects from the bestselling author of "), _c('i', [_vm._v("Wool Appliqué Folk Art")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("Rebekah L. Smith’s Americana aesthetic, although very true to early decorative arts, will look great in many homes today. Presented in a lovely antique color palette, these simple and elegant projects include a journal cover, pillow cover, wall hangings, storage boxes, table rug, and more, perfect for your home or to give as gifts. Includes a basics chapter and an updated chapter on the collection, storage, and use of wool."), _c('br'), _c('br'), _vm._v("• Beginner-friendly projects with downloadable full-size patterns, ranging from a pillow and blanket carrier to a tea cozy and table runner"), _c('br'), _c('br'), _vm._v("• Includes a beautiful styled photo of each project, as well as detail shots to show the gorgeous stitching"), _c('br'), _c('br'), _vm._v("• Award-winning folk artist Rebekah Smith’s historically inspired designs are perfect for traditional quilters, textile artisans, rug hookers, and anyone who appreciates her signature style\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rebekah L. Smith\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rebekah L Smith Bio: Rebekah L. Smith studied graphic design at the Art Institute of Pittsburgh and specializes in wool work, murals, and American folk art. Rebekah and her husband, along with their three daughters, continually work to restore an 1838 house in Ohio. rebekahlsmith.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing, Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0